import { useCallback, useState } from 'react';

type UsePopoverReturnType = {
  toggle: (event: React.MouseEvent<HTMLButtonElement>) => void;
  close: () => void;
  isOpen: boolean;
  id: string | undefined;
  anchorEl: HTMLButtonElement | null;
};

export const usePopover = (id: string): UsePopoverReturnType => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLButtonElement>(null);

  const handleToggle = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>): void => {
      setAnchorEl(anchorEl ? null : event.currentTarget);
    },
    [anchorEl, setAnchorEl],
  );

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  const isOpen = Boolean(anchorEl);
  const elementId = isOpen ? id : undefined;

  return {
    isOpen,
    id: elementId,
    anchorEl,
    toggle: handleToggle,
    close: handleClose,
  };
};
